import TransHistoryBene from './container'

export default TransHistoryBene
